<template>
    <v-data-table
            :headers="headers"
            :items="members"
            hide-actions
            class="elevation-1"
    >
        <template slot="headerCell" slot-scope="props">
            <v-tooltip top max-width="400">
                <span slot="activator">
                    <span v-if="props.header.icon && !props.header.text"><img style="display:inline;" :src="`/static/img/icons/${props.header.icon}.png`"></span>
                    <span v-else-if="props.header.icon" class="header-icon-container" :style="`background-image: URL('/static/img/icons/${props.header.icon}.png');`">
                        <center><span class="header-icon-caption">{{props.header.subtitle}}</span></center>
                    </span>
                    <span v-else>
                    {{ props.header.text }}
                    </span>
                </span>
                <span v-html="props.header.tooltip || props.header.text"></span>
            </v-tooltip>
        </template>

        <template slot="items" slot-scope="props">
            <td v-if="members && members.length > 1"><elv-avatar-icon :avatar="props.item.avatar" width="32"/></td>
            <td v-if="members && members.length > 1" ><router-link :to="'/player/'+ props.item.server + '/' + props.item.playerId">{{ props.item.username }}</router-link></td>
            <td><vue-numeric :value="props.item.cityReport.wonderLevels"/></td>
            <td><span :title="`${props.item.cityReport.cultureBoostPercent}`"><img :src="`/static/img/icons/culture_boost_${props.item.cityReport.cultureBoostPercent}.png`"></span></td>
            <td><vue-numeric :value="(props.item.cityReport.totalPopulation||0) + (props.item.cityReport.bonusPopulation||0)"/></td>
            <td><vue-numeric :value="props.item.cityReport.workingPopulation"/></td>
            <td><vue-numeric :value="props.item.cityReport.availablePopulation" v-bind:class="{ negativeValue: props.item.cityReport.production.availablePopulation < 0, positiveValue: props.item.cityReport.production.availablePopulation > 0}"/></td>
            <td><vue-numeric :value="(props.item.cityReport.totalCulture||0) + (props.item.cityReport.bonusCulture||0)"/></td>
            <td><vue-numeric :value="props.item.cityReport.requiredCulture"/></td>
            <td><vue-numeric :value="props.item.cityReport.availableCulture" v-bind:class="{ negativeValue: props.item.cityReport.production.availablePopulation < 0, positiveValue: props.item.cityReport.production.availablePopulation > 0}"/></td>
        </template>
        <template slot="no-data">
            <v-alert :value="true" color="error" icon="warning">
                Sorry, nothing to display here :(
            </v-alert>
        </template>
    </v-data-table>
</template>

<script>
    import VueNumeric from 'vue-numeric';
    import ElvAvatarIcon from "./ElvAvatarIcon"
    export default {
        name: "elv-pop-culture-table",
        props: { members: {required:true} },
        components: {
            ElvAvatarIcon,
            VueNumeric},
        computed: {
            headers: {
                get: function() {
                    let h = [];
                    try {
                        let isSortable = this.members && this.members.length > 1;
                        if( this.members && this.members.length > 1 ) {
                            h.push({text: "", value: 'avatar', sortable: false});
                            h.push({text: this.$i18n.t('site.common.username'), align: 'left', sortable: isSortable, value: 'username'});
                        }
                        h.push({icon: "ancient_wonders", text: "11",subtitle: this.$i18n.t('site.fellowship.popCultureTable.levels'), value: 'cityReport.wonderLevels', sortable: isSortable, tooltip: this.$i18n.t('site.fellowship.popCultureTable.wonderLevelsTip')});
                        h.push({icon: "culture_boost", text: "12",subtitle: this.$i18n.t('site.fellowship.popCultureTable.minBoostPercent'), value: 'cityReport.cultureBoostPercent', sortable: isSortable, tooltip: this.$i18n.t('site.fellowship.popCultureTable.cultureBoostPercentTip')});
                        h.push({icon: 'population', text: "13", subtitle: this.$i18n.t('site.fellowship.popCultureTable.total'), value: 'cityReport.totalPopulation', sortable: isSortable, tooltip: this.$i18n.t('site.fellowship.popCultureTable.totalPopulationTip')});
                        h.push({icon: 'population', text: "14", subtitle: this.$i18n.t('site.fellowship.popCultureTable.working'), value: 'cityReport.workingPopulation', sortable: isSortable, tooltip: this.$i18n.t('site.fellowship.popCultureTable.workingPopulationTip')});
                        h.push({icon: 'population', text: "15", subtitle: this.$i18n.t('site.fellowship.popCultureTable.available'), value: 'cityReport.availablePopulation', sortable: isSortable, tooltip: this.$i18n.t('site.fellowship.popCultureTable.availablePopulationTip')});
                        h.push({icon: 'culture' ,text: "16",subtitle: this.$i18n.t('site.fellowship.popCultureTable.total'), value: 'cityReport.totalCulture', sortable: isSortable, tooltip: this.$i18n.t('site.fellowship.popCultureTable.totalCultureTip')});
                        h.push({icon: 'culture', text: "17",subtitle: this.$i18n.t('site.fellowship.popCultureTable.required'), value: 'cityReport.requiredCulture', sortable: isSortable, tooltip: this.$i18n.t('site.fellowship.popCultureTable.requiredCultureTip')});
                        h.push({icon: 'culture', text: "18",subtitle: this.$i18n.t('site.fellowship.popCultureTable.available'), value: 'cityReport.availableCulture', sortable: isSortable, tooltip: this.$i18n.t('site.fellowship.popCultureTable.availableCultureTip')});
                    }catch(err) {
                        console.error('Unable to generate: ', err);
                    }
                    return h;
                }
            }
        }
    }
</script>

<style scoped>

    .header-icon-caption {
        position:relative;
        top:24px;
        font-size: 95%;
        padding: 0px 2px 0px 2px;
        text-align: center;
        width: 28px;
    }
    .header-icon-container {
        background-repeat: no-repeat;
        background-position-y: top;
        background-position-x: center;
        position:relative;
        top:-4px;
        margin-top: auto;
        margin-bottom: auto;
        margin-right: 5px;
        width:32px;
        min-width:32px;
        height:24px;
        display: inline-block;
    }

    input[type="tel"] {
        margin: 0;
        padding: 0;
        width: 65px;
    }

    th .tooltip {
        position: unset;
        font-family: unset;
        font-size: unset;
        font-style: unset;
        font-weight: unset;
        line-height: unset;
        text-align: unset;
        text-align: left;
        display: unset;
        /* text-decoration:none; */
        /* text-shadow:none; */
        text-transform: uppercase;
        letter-spacing: unset;
        word-break: unset;
        word-spacing: unset;
        word-wrap: unset;
        white-space: unset;
        filter: unset;
        line-break: unset;
        opacity: unset;
        /* line-break:auto; */
    }
</style>


// WEBPACK FOOTER //
// src/components/ElvPopCultureTable.vue